/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

const buildQuery = (params = {}) => {
    const cleaned = Object.entries(params).reduce((acc, [k, v]) => {
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && v.length === 0)) return acc;
        acc[k] = Array.isArray(v) ? v.join(',') : v;
        return acc;
    }, {});
    const qs = new URLSearchParams(cleaned).toString();
    return qs ? `?${qs}` : '';
};

export default {
    bordereauCourtier: async (params) => exeRequest(`/admin/bilans/bordereau-courtier${buildQuery(params)}`, "GET"),

    bordereauProduction: async (params) => exeRequest(`/admin/bilans/bordereau-production${buildQuery(params)}`, "GET"),

    bordereauAssureur: async (params) => exeRequest(`/admin/bilans/bordereau-assureur${buildQuery(params)}`, "GET"),

    clientsActifs: async (params) => exeRequest(`/admin/bilans/clients-actifs${buildQuery(params)}`, "GET"),

    clientsInactifs: async (params) => exeRequest(`/admin/bilans/clients-inactifs${buildQuery(params)}`, "GET"),

    pointJournalier: async (params) => exeRequest(`/admin/bilans/point-journalier${buildQuery(params)}`, "GET"),

    productionJour: async (params) => exeRequest(`/admin/bilans/production-jour${buildQuery(params)}`, "GET"),

    clientsJour: async (params) => exeRequest(`/admin/bilans/clients-jour${buildQuery(params)}`, "GET"),

    paiementsPeriode: async (params) => exeRequest(`/admin/bilans/paiements-periode${buildQuery(params)}`, "GET"),

    etatClients: async (params) => exeRequest(`/admin/bilans/etat-clients${buildQuery(params)}`, "GET"),

    verserBordereauAssureur: async (contratIds, dateVersement) =>
        exeRequest(`/admin/bilans/verser-bordereau-assureur`, "POST", { contratIds, dateVersement }),

    annulerVersement: async (id, raison) =>
        exeRequest(`/admin/bilans/annuler-versement/${id}`, "POST", { raison }),
};
